import { render } from "./EditLohnastus.vue?vue&type=template&id=b4d8ed58&scoped=true"
import script from "./EditLohnastus.vue?vue&type=script&lang=js"
export * from "./EditLohnastus.vue?vue&type=script&lang=js"

import "./EditLohnastus.vue?vue&type=style&index=0&id=b4d8ed58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d8ed58"]])

export default __exports__